import {Component, OnInit} from '@angular/core';
import {BmCustomerAccountObjectBaseComponent} from "../bm-customer-account-object-base.component";


@Component({
    selector: 'bm-customer-account-object-component-side',
    templateUrl: 'bm-customer-account-object-side.component.html',
    standalone: false
})
export class BmCustomerAccountObjectSideComponent extends BmCustomerAccountObjectBaseComponent implements OnInit {


    /**
     * On Object Change. When object is retrieved
     */
    ngOnInit() {
        super.ngOnInit();
    }

}
